import { Modal, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { BatchUpdateTransactionCertificateRequestsTable } from "~/pages/SupplierPortal/TraceabilityRequests/Modals/certificateRequestsBatchModal/BatchUpdateCertificateRequestsTable"
import { useCertificateRequestsBatchModalContext } from "~/pages/SupplierPortal/TraceabilityRequests/Modals/certificateRequestsBatchModal/store/CertificateRequestsBatchModalContext"

export function CertificateRequestsBatchModal() {
  const { t } = useTranslation(["traceability"])
  const { closeBatchModal, batchModalOpen, certificateId } =
    useCertificateRequestsBatchModalContext()

  return (
    <Modal
      opened={batchModalOpen}
      onClose={() => {
        closeBatchModal()
      }}
      returnFocus={false}
      title={<Text size="lg">{t("batchModal.title")}</Text>}
      size="80vw"
    >
      {certificateId && (
        <BatchUpdateTransactionCertificateRequestsTable
          close={closeBatchModal}
        />
      )}
    </Modal>
  )
}
